export const qualityMasters = [
  { value: 1, label: "high", id: "high" },
  { value: 2, label: "middle", id: "middle" },
  { value: 3, label: "low", id: "low" },
] as const;
